import { Loader2 } from 'lucide-react';
import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const SpinnerLoader: React.FC<Props> = ({ width = 50, height = 50 }) => {
  return (
    <div className='ml-auto mr-auto mt-100 fs-400 text-center'>
      <Loader2 size={width} className='kw-spin' />
    </div>
  );
};

export default SpinnerLoader;
